import React, { useEffect } from 'react';
import "../../App.css"
import clsx from 'clsx';
import SideBar from '../custom/sidebar'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Outlet } from "react-router-dom";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import { Menu, MenuItem, Tooltip } from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import $, { contains } from 'jquery';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import del from '../../Assets/img/svg/Del.svg'
import bell from '../../Assets/img/svg/bell.svg'
import { BorderBottom, ExpandLess, ExpandMore } from '@material-ui/icons';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ExitToApp from "@material-ui/icons/ExitToApp";
import { Service } from '../../Authentication/AuthProvider';
import ShipLogo from "../../Assets/img/svg/ShipLogo.svg"
import aheadlogo from '../../Assets/img/svg/aheadlogo.svg';
import aheadlogomob from '../../Assets/img/svg/aheadlogmob.svg';
import shiplogomob from '../../Assets/img/svg/shipLogomob.svg';
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";

// const drawerWidth = window.location.pathname === '/ship/overview' ? 300 : 240;
// const drawerheight = 40;
// const currentUser = JSON.parse(localStorage.getItem("currentUser"));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// const useStyles = makeStyles((theme) => ({
//     root: {
//         display: 'flex',

//     },
//     topMenu: {
//         backgroundColor: "#499AC8",
//         color: "#FFFFFF !important",
//         // width: '100%',
//         // marginLeft: 'auto'
//     },
//     topMenu1: {
//         backgroundColor: "#499AC8",
//         color: "#FFFFFF !important",
//         // width: '100%',
//         // marginLeft: 'auto'
//     },
//     appBar: {
//         zIndex: theme.zIndex.drawer + 1,
//         transition: theme.transitions.create(['width', 'margin'], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen,
//         }),
//         boxShadow: "none !important",
//         // border: "1px solid #F1F1F1",

//     },
//     appBarShift: {
//         marginLeft: window.location.pathname === '/ship/overview' ? 300 : drawerWidth,
//         width: `calc(100% - ${window.location.pathname === '/ship/overview' ? 300 : drawerWidth}px + 1px)`,
//         transition: theme.transitions.create(['width', 'margin'], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//         boxShadow: "none !important",
//         border: "0px solid #F1F1F1",
//         borderLeft: "none",
//     },
//     menuButton: {
//         marginRight: 36,
//     },
//     hide: {
//         display: 'absolute',
//     },
//     hide: {
//         display: 'none',
//     },
//     drawer: {
//         height: 'auto !important',
//         width: window.location.pathname === '/ship/overview' ? 300 : drawerWidth,
//         flexShrink: 0,
//         whiteSpace: 'nowrap',
//     },
//     drawer1: {
//         height: 'auto !important',
//         width: "100%",
//         flexShrink: 0,
//         whiteSpace: 'nowrap',
//         marginTop: 'auto',
//         bottom: 0,

//     },
//     drawerOpen: {
//         width: window.location.pathname === '/ship/overview' ? 300 : drawerWidth,
//         transition: theme.transitions.create('width', {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//         whiteSpace: "pre-line !important",
//         overflowX: "hidden"
//     },

//     drawerOpen1: {
//         width: "100%",
//         transition: theme.transitions.create('width', {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//         whiteSpace: "pre-line !important"
//     },
//     drawerClose: {
//         transition: theme.transitions.create('width', {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen,
//         }),
//         overflowX: 'hidden',
//         width: theme.spacing(7) + 1,
//         [theme.breakpoints.up('sm')]: {
//             width: theme.spacing(7.5) + 0.5,
//         },
//     },
//     toolbar: {
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'flex-end',
//         padding: theme.spacing(0, 1),
//         // necessary for content to be below app bar
//         ...theme.mixins.toolbar,
//     },
//     content: {
//         flexGrow: 1,
//         padding: theme.spacing(3),
//     },
//     Hoverclr: {
//         "& .MuiTabs-indicator": {
//             backgroundColor: "#FFFFFF",
//         }
//     },
//     leftCount: {
//         height: "24px !important",
//         background: "#E2E2E2",
//         boxShadow: "0px 1px 18px rgb(0 0 0 / 4%)",
//         padding: "6px",
//         paddingTop: "4px",
//         maxWidth: "25px"
//     },
//     paperHeight: {
//         "& .MuiDrawer-paper": {
//             height: "auto",
//         }
//     }
// }));

const TopMenu = () => {
    // const drawerWidth = window.location.pathname === '/ship/overview' || ((window.location.pathname === '/shiplist' && localStorage.getItem("UserRoles").toLowerCase() == "client")) ? 300 : 240;
    const drawerWidth = localStorage.getItem("UserRoles").toLowerCase() == "client" ? 300 : window.location.pathname === '/ship/overview' ? 300 : 240;
    const drawerheight = 40;
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',

        },
        topMenu: {
            backgroundColor: "#ffffff",
            // backgroundColor: "#499AC8",
            color: "#000000 !important",
            height: '84px',
            borderBottom: '2px solid #499AC8'
            // width: '100%',
            // marginLeft: 'auto'
        },
        topMenu1: {
            backgroundColor: "#ffffff",
            // backgroundColor: "#499AC8",
            color: "#000000 !important",
            height: '84px',
            borderBottom: '2px solid #499AC8'
            // width: '100%',
            // marginLeft: 'auto'
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            boxShadow: "none !important",
            // border: "1px solid #F1F1F1",

        },
        appBarShift: {
            marginLeft: window.location.pathname === '/ship/overview' ? 300 : drawerWidth,
            width: `calc(100% - ${window.location.pathname === '/ship/overview' ? 300 : drawerWidth}px + 1px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxShadow: "none !important",
            border: "0px solid #F1F1F1",
            borderLeft: "none",
        },
        menuButton: {
            marginRight: 36,
        },
        hide: {
            display: 'absolute',
        },
        hide: {
            display: 'none',
        },
        drawer: {
            height: 'auto !important',
            width: window.location.pathname === '/ship/overview' ? 300 : drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawer1: {
            height: 'auto !important',
            width: "100%",
            flexShrink: 0,
            whiteSpace: 'nowrap',
            marginTop: 'auto',
            bottom: 0,

        },
        drawerOpen: {
            width: window.location.pathname === '/ship/overview' ? 300 : drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            whiteSpace: "pre-line !important",
            overflowX: "hidden"
        },

        drawerOpen1: {
            width: "100%",
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            whiteSpace: "pre-line !important"
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7) + 1,
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(7.5) + 0.5,
            },
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        Hoverclr: {
            "& .MuiTabs-indicator": {
                backgroundColor: "#000000",
            }
        },
        leftCount: {
            height: "24px !important",
            background: "#E2E2E2",
            boxShadow: "0px 1px 18px rgb(0 0 0 / 4%)",
            padding: "6px",
            paddingTop: "4px",
            maxWidth: "25px"
        },
        paperHeight: {
            "& .MuiDrawer-paper": {
                height: "auto",
            }
        }
    }));
    const classes = useStyles();

    let menuToggle = useSelector(state => state.commonReducer.menuToggle);
    let cancel = useSelector(state => state.commonReducer.alertCancel);
    let richcancel = useSelector(state => state.commonReducer.richtextCancel);
    let richText = useSelector(state => state.commonReducer.richtext);
    let richcancel1 = useSelector(state => state.commonReducer.richtextCancel1);
    let richText1 = useSelector(state => state.commonReducer.richtext1);
    let sideBar = useSelector(state => state.commonReducer.sidePanel);

    const dispatch = useDispatch();
    const theme = useTheme();
    const [mobevent, setEvent] = React.useState("");
    const [elink, setelink] = React.useState("");
    const [strName, setstrName] = React.useState("");
    const [funCall, setfunCall] = React.useState("");
    const [open, setOpen] = React.useState(true);
    const [isMobile, setisMobile] = React.useState(false);
    const [topBarCheck, settopBarCheck] = React.useState(false);
    const [collapseCheck, setcollapseCheck] = React.useState(false);
    const [expandCheck, setexpandCheck] = React.useState(false);
    const [value, setValue] = React.useState(0);
    const [shiptype, setShipType] = React.useState(0);
    const [topmoresize, setTopMoreSize] = React.useState(false);
    const [less, setLess] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [topBar, settopBar] = React.useState(false);
    const [reSize, setreSize] = React.useState(false);
    const [sized, setsized] = React.useState(false);
    const [anchorEl1, setAnchorEl1] = React.useState(null);
    const [isGradeApplicable, setIsGradeApplicable] = React.useState(localStorage.getItem("IsGradeApplicable") === "true" || localStorage.getItem("IsGradeApplicable") === true);
    const navigate = useNavigate();

    useEffect(() => {
        const updateGrade = () => {
            const val = localStorage.getItem("IsGradeApplicable") === "true" || localStorage.getItem("IsGradeApplicable") === true;
            setIsGradeApplicable(val);
        };
        window.addEventListener('isGradeApplicableChanged', updateGrade);
        window.addEventListener('storage', updateGrade);
        const interval = setInterval(updateGrade, 200);
        return () => {
            window.removeEventListener('isGradeApplicableChanged', updateGrade);
            window.removeEventListener('storage', updateGrade);
            clearInterval(interval);
        };
    }, []);
    const MyOptions = [
        'Logout'
    ];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClick1 = (event) => {

        setEvent(event.currentTarget)
        if (cancel) {
            window.$("#cancelpopup2").modal("show");
        }
        else {
            dispatch({ type: "CANCEL", data: false });
            setAnchorEl1(event.currentTarget);
        }
    };

    const SideBarCancel = () => {
        dispatch({ type: "RICHTEXT", data: false });
        dispatch({ type: "RICHTEXT1", data: false });
        window.$("#cancelpopup2").modal("hide");
        setAnchorEl1(mobevent);
    };

    const opens = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const opens1 = Boolean(anchorEl1);

    const handleClose1 = () => {
        setAnchorEl1(null);
    };
    const handleLogout = () => {
        Service.logout();
    };

    const handleToggle = () => {
        setexpandCheck(!expandCheck);
    }

    const resize = () => {
        setShipType(parseInt(localStorage.getItem("ShipType")));
        $(".select-dropdown").removeClass("dropdown-toggle");
        if (window.innerWidth < 850) { setisMobile(true) }
        else { setisMobile(false) }
        if (window.innerWidth <= 330) { settopBarCheck(true) }
        else { settopBarCheck(false) }
        if (window.innerWidth >= 850 && window.innerWidth <= 1050) { setcollapseCheck(true) }
        else { setcollapseCheck(false) }
        if (localStorage.getItem("UserRoles") === "Admin" && (window.location.pathname === '/shiplist' || window.location.pathname === '/shipparticulars/add' || window.location.pathname === '/incharge/add' || window.location.pathname === '/settings/add' ||
            window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
            window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspector/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
            window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
            window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit' || window.location.pathname === '/sampleships' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit')) {
            window.location.pathname === "/shiplist" ? setValue(0) :
                (window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
                    window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspector/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
                    window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
                    window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit'

                ) ? setValue(1) :
                    (window.location.pathname === '/sampleships' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit') ? setValue(2) :

                        <></>
        } else if (localStorage.getItem("UserRoles") === "Client" && (window.location.pathname === '/shiplist' || window.location.pathname === '/newenquiry')) {
            window.location.pathname === "/shiplist" ? setValue(0) :
                (window.location.pathname === '/newenquiry') ? setValue(1) :
                    <></>
        }
        else {
            if (localStorage.getItem("UserRoles") == "Admin") {
                window.location.pathname === "/shipparticulars/edit" ? setValue(0) :
                    window.location.pathname === "/ship/documents" ? setValue(1) :
                        window.location.pathname === "/ship/photographs" ? setValue(2) :
                            (window.location.pathname.includes('/inspection')) ? setValue(3) :
                                window.location.pathname === "/finalreport" ? setValue(4) : <></>
            }
            if (localStorage.getItem("UserRoles") == "FieldInspector") {
                window.location.pathname === "/shipparticulars/edit" ? setValue(0) :
                    (window.location.pathname.includes('/inspection')) ? setValue(1) : <></>
            }
            if (localStorage.getItem("UserRoles") == "Client") {
                window.location.pathname === "/shipparticulars/edit" ? setValue(0) :
                    window.location.pathname === "/ship/documents" ? setValue(1) :
                        window.location.pathname === "/ship/photographs" ? setValue(2) :
                            window.location.pathname === "/finalreport" ? setValue(3) : <></>
            }
            if (localStorage.getItem("UserRoles") == "External Client") {
                window.location.pathname === "/shipparticulars/edit" ? setValue(0) :
                    window.location.pathname === "/ship/documents" ? setValue(1) :
                        window.location.pathname === "/ship/photographs" ? setValue(2) :
                            window.location.pathname === "/finalreport" ? setValue(3) : <></>
            }
        }
    };

    const resizes = () => {
        if (window.innerWidth < 1268) { settopBar(true) }
        else { settopBar(false) }
    };

    const resizing = () => {
        if (window.innerWidth < 1300) { setreSize(true) }
        else { setreSize(false) }
    };

    const resized = () => {
        if (window.innerWidth < 850) { setsized(true) }
        else { setsized(false) }
    };
    const resizedTop = () => {
        if (window.innerWidth < 1000) { setTopMoreSize(true) }
        else { setTopMoreSize(false) }
    };
    const handleChange = (event, newValue) => {
        setfunCall("handelchanges");
        setelink(newValue)
        setValue(newValue);
        let SummeryResult = window["getsummernote_code"]();
        let SummeryResult1 = window["getsummernote_code1"]();
        // if (cancel || (SummeryResult != richcancel && richText == true && SummeryResult != '<p><br></p>') || (SummeryResult1 != richcancel1 && richText1 == true && SummeryResult1 != '<p><br></p>')) {
        //     window.$("#cancelpopupPro").modal("show");
        // }
        if (cancel ) {
            window.$("#cancelpopupPro").modal("show");
        }
        else {
            dispatch({ type: "CANCEL", data: false });
            dispatch({ type: "RICHTEXT", data: false });
            dispatch({ type: "RICHTEXT1", data: false });
            handelchanges(newValue)
        }
    };

    const handelchanges = (newValue) => {
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal2").trigger("click")
        $("#closemodal3").trigger("click")
        setValue(newValue);
        if ((window.location.pathname === '/shiplist' || window.location.pathname === '/shipparticulars/add' || window.location.pathname === '/incharge/add' || window.location.pathname === '/settings/add' ||
            window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
            window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspectorr/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
            window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
            window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit' || window.location.pathname === '/newenquiry' || window.location.pathname === '/activesampleships'
            || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit' || window.location.pathname === '/sampleships'
        )) {
            if (localStorage.getItem("UserRoles") == "Admin") {
                newValue == 0 ? navigate("/shiplist") : newValue == 1 ? navigate("/usermanagement/admin") : newValue == 2 ? navigate("/sampleships") : <></>
            }
            if (localStorage.getItem("UserRoles") == "Client") {
                newValue == 0 ? navigate("/shiplist") : newValue == 1 ? navigate("/newenquiry") : <></>
            }
        }
        else {
            if (localStorage.getItem("UserRoles") == "Admin") {
                newValue == 0 ? navigate("/shipparticulars/edit") : newValue == 1 ? navigate("/ship/documents") : newValue == 2 ? navigate("/ship/photographs") : newValue == 3 ? navigate("/inspection/vesselparticular") : newValue == 4 ? navigate("/finalreport") : navigate("/shiplist");
            }
            if (localStorage.getItem("UserRoles") == "FieldInspector") {
                newValue === 0 ? navigate("/shipparticulars/edit") : newValue === 1 ? navigate("/inspection/vesselparticular") : <></>;
            }
            if (localStorage.getItem("UserRoles") == "Client") {
                newValue == 0 ? navigate("/ship/overview") : newValue == 1 ? navigate("/ship/documents") : newValue == 2 ? navigate("/ship/photographs") : newValue == 3 ? navigate("/finalreport") : <></>;
            }
            if (localStorage.getItem("UserRoles") == "External Client") {
                newValue == 0 ? navigate("/ship/overview") : newValue == 1 ? navigate("/ship/documents") : newValue == 2 ? navigate("/ship/photographs") : newValue == 3 ? navigate("/finalreport") : <></>;
            }
        }
    }
    const handleDrawerOpen = () => {
        setOpen(true);
        setToggle1();
    };
    const swapDrawerOpen = () => {
        !open ? handleDrawerOpen() : handleDrawerClose()
    }
    const handleDrawerClose = () => {
        setOpen(false);
        setToggle();
    };

    const ProjectNavigation = (e, str) => {
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal2").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("/shipparticulars/add") :
            e === 2 ? navigate("/incharge/add") :
                e === 3 ? navigate("/settings/add") : navigate("")
    };

    const MasterDataNavigation = (e) => {
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")

        e === 1 ? navigate("/lookupdata/opa") :
            navigate("")
    };

    const UserMgntNavigation = (e) => {
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal2").trigger("click")
        $("#closemodal3").trigger("click")
        e === 1 ? navigate("/usermanagement/admin") :
            e === 2 ? navigate("/usermanagement/fieldinspector") :
                e === 3 ? navigate("/usermanagement/client") :
                    e === 4 ? navigate("/usermanagement/externalclient") : navigate("")
    }

    const ExternalMgntNavigation = (e) => {
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal2").trigger("click")
        $("#closemodal3").trigger("click")
        e === 1 ? navigate("/sampleships") :
            e === 2 ? navigate("/activesampleships") : navigate("")
    }
    const EditNavigation = (e, str) => {
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#viewscreen1").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal2").trigger("click")
        $("#closemodal3").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("/shipparticulars/edit") :
            e === 2 ? navigate("/incharge/edit") :
                e === 3 ? navigate("/settings/edit") :
                    e === 4 ? navigate("/historylog") :
                        e === 5 ? navigate("ship/finalsubmit") :
                            e === 6 ? navigate("/deleteship/deleteship") : navigate("")
    };

    const SetActive3 = (e, str) => {
        dispatch({ type: "CANCEL", data: false });
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen1").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("") :
            e === 2 ? navigate("/usermanagement/admin") :
                e === 3 ? navigate("/sampleships") : navigate("")
    };

    const SetActive2 = (e, str) => {
        dispatch({ type: "CANCEL", data: false });
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("/ship/overview") :
            e === 2 ? navigate("/ship/documents") :
                e === 3 ? navigate("/ship/photographs") :
                    e === 4 ? navigate("/finalreport") : navigate("")
    }

    const SetActive4 = (e, str) => {
        dispatch({ type: "CANCEL", data: false });
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("") :
            e === 2 ? navigate("/newenquiry") : navigate("")
    }

    const SetActive5 = (e, str) => {
        dispatch({ type: "CANCEL", data: false });
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("/shipparticulars/edit") :
            e === 2 ? navigate("/ship/documents") :
                e === 3 ? navigate("/ship/photographs") :
                    e === 4 ? navigate("/inspection/vesselparticular") :
                        e === 5 ? navigate("/finalreport") : navigate("")
    }

    const SetActive6 = (e, str) => {
        dispatch({ type: "CANCEL", data: false });
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("/shipparticulars/edit") :
            e === 2 ? navigate("/inspection/vesselparticular") : navigate("")
    }
    const SetActive7 = (e, str) => {
        dispatch({ type: "CANCEL", data: false });
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        e === 1 ? navigate("/ship/overview") :
            e === 2 ? navigate("/ship/documents") :
                e === 3 ? navigate("/ship/photographs") :
                    e === 4 ? navigate("/finalreport") : navigate("")
    }

    useEffect(() => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        setOpen(true);

        setToggle1();
        let e = localStorage.getItem("DashId")
        const intervals = setInterval(() => {
            timeinterval()
        }, 10);
        return () => clearInterval(intervals);
    }, []);

    const timeinterval = () => {
        resize();
        resizes();
        resizing();
        resized();
        resizedTop();
    }

    const editnavigate = (str, str1) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        setfunCall(str1);
        setstrName(str);
        if (cancel) {
            window.$("#cancelpopupPro").modal("show");
        }
        else {
            dispatch({ type: "CANCEL", data: false });
            navigate(str)
        }
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
    }

    const DailyNavigation = (str, path) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        navigate(path);
    }

    const SetActive = (str) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal2").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal1").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        if (str === "sampleships" || str === "activesampleships" || str === "H" || str === "C") {
            navigate(str)
        }
    }

    const DailyTasknavigate = (str) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        $("#viewscreen1").trigger("click")
        $("#viewscreen").trigger("click")
        $("#viewscreen0").trigger("click")
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $("#closemodal3").trigger("click")
        $("#closemodal2").trigger("click")
        navigate(str)

    }
    const setToggle = () => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        dispatch({ type: "MENU_TOGGLE", data: false })
    }
    const setToggle1 = () => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        dispatch({ type: "MENU_TOGGLE", data: true })
    }
    const projectNameClick = (path) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        setfunCall(path);
        let SummeryResult = window["getsummernote_code"]();
        let SummeryResult1 = window["getsummernote_code1"]();
        if (cancel ) {
            window.$("#cancelpopupPro").modal("show");
        }
        // if (cancel || (SummeryResult != richcancel && richText == true && SummeryResult != '<p><br></p>') || (SummeryResult1 != richcancel1 && richText1 == true && SummeryResult1 != '<p><br></p>')) {
        //     window.$("#cancelpopupPro").modal("show");
        // }
        else {
            dispatch({ type: "CANCEL", data: false });
            dispatch({ type: "RICHTEXT", data: false });
            dispatch({ type: "RICHTEXT1", data: false });
            if (localStorage.getItem("UserRoles") === "Admin") {
                navigate(path)
            }
        }
    }
    const Cancel = () => {
        dispatch({ type: "RICHTEXT", data: false });
        dispatch({ type: "RICHTEXT1", data: false });
        $(".select-dropdown").removeClass("dropdown-toggle");
        dispatch({ type: "CANCEL", data: false });
        if (funCall === "ProjectNavigation") {
            ProjectNavigation(elink, strName)
        }
        if (funCall === "EditNavigation") {
            EditNavigation(elink, strName)
        }
        if (funCall === "edit") {
            navigate(strName)
        }
        if (funCall === "UserMgntNavigation") {
            UserMgntNavigation(elink)
        }
        if (funCall === "ExternalMgntNavigation") {
            ExternalMgntNavigation(elink)
        }
        if (funCall === "DailyTasknavigate") {
            DailyTasknavigate(elink)
        }
        if (funCall === "DailyNavigation") {
            DailyNavigation(elink, strName)
        }
        if (funCall === "handelchanges") {
            handelchanges(elink)
        }
        if (funCall === "/shipparticulars/edit") {
            navigate(funCall)
        }
        if (funCall === "/changepassword") {
            navigate(funCall)
        }
        if (funCall === "handleLogout") {
            handleLogout()
        }
        window.$("#cancelpopupPro").modal("hide");
    }
    const CancelPopup = (e, str, fcall) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        setelink(e)
        setstrName(str);
        setfunCall(fcall);
        if (cancel) {
            window.$("#cancelpopupPro").modal("show");
        }
        else {
            dispatch({ type: "CANCEL", data: false });
            if (fcall === "ProjectNavigation") {
                ProjectNavigation(e, str)
            }
            if (fcall === "EditNavigation") {
                EditNavigation(e, str)
            }
        }
    }
    const CancelPopupUser = (e, fcall) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        setelink(e)
        setfunCall(fcall);
        if (cancel) {
            window.$("#cancelpopupPro").modal("show");
        }
        else {
            dispatch({ type: "CANCEL", data: false });
            if (fcall === "UserMgntNavigation") {
                UserMgntNavigation(e)
            }
            if (fcall === "DailyTasknavigate") {
                DailyTasknavigate(e)
            }
            if (fcall === "ExternalMgntNavigation") {
                ExternalMgntNavigation(e)
            }
        }
    }
    const CopyDaily = (e, path, fcall) => {
        $(".select-dropdown").removeClass("dropdown-toggle");
        setelink(e)
        setstrName(path);
        setfunCall(fcall);
        let SummeryResult = window["getsummernote_code"]();
        let SummeryResult1 = window["getsummernote_code1"]();
        if (cancel) {
            window.$("#cancelpopupPro").modal("show");
        }
        // if (cancel || (SummeryResult != richcancel && richText == true && SummeryResult != '<p><br></p>') || (SummeryResult1 != richcancel1 && richText1 == true && SummeryResult1 != '<p><br></p>')) {
        //     window.$("#cancelpopupPro").modal("show");
        // }
        else {
            dispatch({ type: "CANCEL", data: false });
            dispatch({ type: "RICHTEXT", data: false });
            dispatch({ type: "RICHTEXT1", data: false });
            if (fcall === "DailyNavigation") {
                DailyNavigation(e, path)
            }
        }
    }
    const ChangePwd = (path) => {
        setfunCall(path);
        if (cancel) {
            window.$("#cancelpopupPro").modal("show");
        }
        else {
            dispatch({ type: "CANCEL", data: false });
            if (path === "/changepassword") {
                navigate("/changepassword")
            }
        }
    }
    const LogOutView = (path) => {
        setfunCall(path);
        if (cancel) {
            window.$("#cancelpopupPro").modal("show");
        }
        else {
            dispatch({ type: "CANCEL", data: false });
            if (path === "handleLogout") {
                handleLogout()
            }
        }
    }
    return (

        <div>
            {isMobile ?
                <div className={classes.root}>
                    <CssBaseline />
                    <AppBar position="fixed" style={{ zIndex: 9999, minHeight: '64px' }}>
                        <Toolbar className={window.location.pathname == "/ship/overview" ? classes.topMenu1 : localStorage.getItem("UserRoles").toLowerCase() === "client" ? classes.topMenu1 : classes.topMenu} style={{ minHeight: '64px' }}>
                            <div className={topBarCheck ? "row " : "row w-100 "} style={topBarCheck ? { flex: 1 } : {}}>
                                <div className={`col-8 col-sm-8 col-md-8 mr-0 ${topBarCheck ? " pr-0" : ""}`}>
                                    <div className="row d-flex align-items-center" style={{ minWidth: '300px' }}>
                                        <div className="col-1 col-sm-1 col-md-1">
                                            {(localStorage.getItem("UserRoles") == "FieldInspector" && window.location.pathname === '/shiplist') ? <></> :
                                                <IconButton
                                                    color="inherit"
                                                    aria-label="open drawer"
                                                    // onClick={sideBar ? setSideBar : setSideBar1}
                                                    edge="start"
                                                    onClick={handleClick1}
                                                    className={clsx(classes.menuButton, {
                                                        [classes.hide1]: open,
                                                    })}
                                                >
                                                    <MenuIcon />
                                                </IconButton >}
                                            <Menu
                                                style={{ position: 'fixed', marginTop: "60px", width: "100%", height: "100%", backgroundColor: "#F6F6F6", overflowY: 'auto' }}
                                                anchorEl={anchorEl1}
                                                keepMounted onClose={handleClose1}
                                                open={opens1}>
                                                {(localStorage.getItem("UserRoles") === "Admin" && (window.location.pathname === '/shiplist' || window.location.pathname === '/shipparticulars/add' || window.location.pathname === '/incharge/add' || window.location.pathname === '/settings/add' ||
                                                    window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
                                                    window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspector/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
                                                    window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
                                                    window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit' ||
                                                    window.location.pathname === '/sidebarmasterdata' || window.location.pathname === '/SidebarUser' || window.location.pathname === '/deleteship/deleteship' || window.location.pathname === '/sampleships'
                                                )) ? ['Ships', 'Users', 'Sample Ships'].map((text, index) => (
                                                    <MenuItem className="pl-0" style={{ width: "330px", backgroundColor: "#F6F6F6" }} onClick={handleClose1}>
                                                        <ListItem className="" button key={text} onClick={() => SetActive3(index + 1, text.replaceAll(" ", ""))}>
                                                            <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                                            <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                                        </ListItem> </MenuItem>
                                                )) :
                                                    (localStorage.getItem("UserRoles") === "Client" && (window.location.pathname === '/shiplist' || window.location.pathname === '/newenquiry'
                                                    )) ?
                                                        ['Ship', 'New Enquiry'].map((text, index) => (
                                                            <MenuItem className="pl-0" style={{ width: "330px", backgroundColor: "#F6F6F6" }} onClick={handleClose1}>
                                                                <ListItem className="" button key={text} onClick={() => SetActive4(index + 1, text.replaceAll(" ", ""))}>
                                                                    <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                                                    <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                                                </ListItem> </MenuItem>
                                                        )) : localStorage.getItem("UserRoles") === "Admin" ?
                                                            ['Ship', 'Documents', 'Photographs', 'Inspection Tasks', 'Report'].map((text, index) => (
                                                                <MenuItem className="pl-0" style={{ width: "330px", backgroundColor: "#F6F6F6" }} onClick={handleClose1}>
                                                                    <ListItem className="" button key={text} onClick={() => SetActive5(index + 1, text.replaceAll(" ", ""))}>
                                                                        <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                                                        <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                                                    </ListItem> </MenuItem>
                                                            ))
                                                            : localStorage.getItem("UserRoles") === "FieldInspector" ? ['Ship', 'Inspection Tasks'].map((text, index) => (
                                                                <MenuItem className="pl-0" style={{ width: "330px", backgroundColor: "#F6F6F6" }} onClick={handleClose1}>
                                                                    <ListItem className="" button key={text} onClick={() => SetActive6(index + 1, text.replaceAll(" ", ""))}>
                                                                        <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                                                        <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                                                    </ListItem> </MenuItem>
                                                            )) : localStorage.getItem("UserRoles") === "External Client" ?
                                                                ['Overview', 'Documents', 'Photographs', 'Report'].map((text, index) => (
                                                                    <MenuItem className="pl-0" style={{ width: "330px", backgroundColor: "#F6F6F6" }} onClick={handleClose1}>
                                                                        <ListItem className="" button key={text} onClick={() => SetActive7(index + 1, text.replaceAll(" ", ""))}>
                                                                            <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                                                            <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                                                        </ListItem> </MenuItem>
                                                                ))
                                                                : ['Overview', 'Documents', 'Photographs', 'Reports'].map((text, index) => (
                                                                    <MenuItem className="pl-0" style={{ width: "330px", backgroundColor: "#F6F6F6" }} onClick={handleClose1}>
                                                                        <ListItem className="" button key={text} onClick={() => SetActive2(index + 1, text.replaceAll(" ", ""))}>
                                                                            <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                                                            <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                                                        </ListItem> </MenuItem>
                                                                ))}
                                            </Menu>
                                        </div>
                                        {window.location.pathname === '/ship/overview' || localStorage.getItem("UserRoles").toLowerCase() === "client" ? <>
                                            <div className="col-6 col-sm-6 col-md-6 pl-3 pt-1 pr-0 d-flex"  >
                                                <img src={aheadlogomob} style={{ height: '130%', marginTop: '-11px', marginLeft: '-4px', width: '112%' }} />
                                            </div>
                                            {/* <div className="col-2 col-sm-3 col-md-2 pl-2 pt-1 pr-0 d-flex"  >
                                                <img src={shiplogomob} style={{ marginLeft: '5px' }} />
                                            </div>
                                            <div className="col-3 col-sm-4 col-md-5 pl-3 pt-2 d-flex " >
                                                <h5 className='fw-600' style={{ fontWeight: "bolder", fontSize: '13px', marginLeft: localStorage.getItem("UserRoles").toLowerCase() == "client" ? '10px' : '' }}>Marine<br></br>Mechanics</h5>
                                            </div> */}
                                        </> :
                                            <>
                                                <div className="col-7 col-sm-7 col-md-7 pl-3 pt-0 py-0 pr-0 d-flex align-items-center" >
                                                    <img src={aheadlogo} height={'74px'} />
                                                </div>
                                                {/* <div className="col-8 col-sm-9 col-md-9 pl-3 pt-2">
                                                    <h5 className='f-size-13 fw-600' style={{ fontWeight: "bolder" }}>Marine<br></br>Mechanics</h5>
                                                </div> */}
                                            </>}

                                    </div>
                                </div>
                                <div className={`col-4 col-sm-4 col-md-4  my-auto row mr-0 ${topBarCheck ? " pl-0" : ""}`} >
                                    <div className={`row justify-content-end d-flex ${topBarCheck ? " pl-0" : ""}`} >
                                        {/* <div className="col-7 col-sm-7 col-md-7 pt-2 mr-1 text-right pr-0">
                                            <img src={bell} style={{ width: "25px", height: "25px" }} />
                                        </div> */}
                                        <div className="col-11 d-flex justify-content-end col-sm-11 col-md-11 float-end pl-1 pt-1 mt-1 mr-0">
                                            {currentUser ? (
                                                <UncontrolledDropdown className="mr-right">
                                                    <DropdownToggle nav caret className="select-dropdown">
                                                        <IconButton
                                                            className="p-0"
                                                            aria-label="more"
                                                            onClick={handleClick}
                                                            aria-haspopup="true"
                                                            aria-controls="long-menu"
                                                        ><MoreVertIcon style={{ color: "#000000" }} />
                                                        </IconButton>
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        <h5 className="dropdown-item-text mb-0">
                                                            {currentUser.name.split("@")[0]}
                                                        </h5>
                                                        <p className="dropdown-item-text text-muted mb-0 fontSize-dropdown">
                                                            {currentUser.email}
                                                        </p>
                                                        <DropdownItem divider />
                                                        <DropdownItem className='fontSize-dropdown' onClick={() => ChangePwd("/changepassword")}>
                                                            Change Password
                                                        </DropdownItem>
                                                        <DropdownItem divider />

                                                        <DropdownItem className='fontSize-dropdown' onClick={() => LogOutView("handleLogout")}>
                                                            Sign Out
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Toolbar>
                    </AppBar>
                </div>
                :
                <div className={classes.root}>
                    <CssBaseline />
                    <AppBar
                        position="fixed"
                        className={clsx(classes.appBar, {
                            [classes.appBarShift]: open,
                        })}
                        color="inherit"

                    >
                        <Toolbar className={window.location.pathname == "/ship/overview" ? classes.topMenu1 : localStorage.getItem("UserRoles").toLowerCase() === "client" ? classes.topMenu1 : classes.topMenu} >
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, {
                                    [classes.hide]: open,
                                })}
                            >
                                <MenuIcon />
                            </IconButton >
                            <div className="row w-100" >
                                {topBar ? <></> :
                                    <div className="col-md-3 col-lg-3 pl-0 ml-0 mt-1 pr-0 mr-0 col-xl-3 d-flex align-items-center" >
                                        {(window.location.pathname === '/shiplist' || window.location.pathname === '/shipparticulars/add' || window.location.pathname === '/incharge/add' ||   /* window.location.pathname === '/introduction/add' || window.location.pathname === '/process/add' */  window.location.pathname === '/settings/add' ||
                                            window.location.pathname === '/lookupdata/opa' || window.location.pathname === '/lookupdata/opa/add' || window.location.pathname === '/lookupdata/opa/edit' ||
                                            window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
                                            window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspector/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
                                            window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
                                            window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit' || window.location.pathname === '/sampleships' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit'
                                        ) ? <label className="pt-1 f-size-15 fw-600 mt-1">Vessel Inspection System</label> :
                                            <div className="pt-0 f-size-15 word-break overflow fw-600 text-decoration-none text-black cursorPointer" onClick={() => { projectNameClick("/shipparticulars/edit") }}>
                                                {localStorage.getItem("ShipName") && localStorage.getItem("ShipName")}
                                            </div>}
                                    </div>}
                                <div className={topBar ? "col-md-11 col-lg-11 col-xl-11 d-flex justify-content-end align-items-center" : reSize ? "col-lg-7 col-md-7 col-xl-7 d-flex justify-content-end align-items-center" : sized ? "col-lg-10 col-md-10 col-xl-10 d-flex justify-content-end align-items-center" : "col-md-7 col-lg-7 col-xl-7 d-flex justify-content-end align-items-center"} style={{ borderRight: "1px solid #499AC8" }}>
                                    {window.location.pathname === "/changepassword" ? <></> : <>
                                        {(localStorage.getItem("UserRoles") == "Admin" && (window.location.pathname === '/shiplist' || window.location.pathname === '/shipparticulars/add' || window.location.pathname === '/incharge/add' || window.location.pathname === '/settings/add' ||
                                            window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
                                            window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspector/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
                                            window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
                                            window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit' || window.location.pathname === '/sampleships'
                                        )) ? <>
                                            <Tabs value={value} onChange={handleChange} className={classes.Hoverclr} aria-label="simple tabs example">
                                                <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "50px" : "80px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Ships" {...a11yProps(0)} />
                                                <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "50px" : '80px', textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Users" {...a11yProps(1)} />
                                                <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "50px" : '80px', textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Sample Ships" {...a11yProps(7)} />
                                            </Tabs></>
                                            : <>{(localStorage.getItem("UserRoles") == "FieldInspector" && window.location.pathname === '/shiplist') || (localStorage.getItem("UserRoles") == "External Client" && window.location.pathname === '/shiplist')
                                                ? <><Tabs value={value} onChange={handleChange} className={classes.Hoverclr} aria-label="simple tabs example">
                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "80px" : "80px", maxWidth: sized ? "50px" : "50px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Ships" {...a11yProps(0)} />
                                                </Tabs> </>
                                                :
                                                localStorage.getItem("UserRoles") == "Client" && (window.location.pathname === '/shiplist' || window.location.pathname == '/newenquiry')
                                                    ? <><Tabs value={value} onChange={handleChange} className={classes.Hoverclr} aria-label="simple tabs example">
                                                        <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "80px" : "80px", maxWidth: sized ? "50px" : "50px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Ships" {...a11yProps(0)} />
                                                        <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "120px" : "120px", maxWidth: sized ? "100px" : "100px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="New Enquiry" {...a11yProps(5)} />
                                                    </Tabs>
                                                    </>
                                                    : localStorage.getItem("UserRoles") == "FieldInspector"
                                                        ? <>
                                                            <Tabs value={value} onChange={handleChange} className={classes.Hoverclr} aria-label="simple tabs example">
                                                                <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "80px" : "80px", maxWidth: sized ? "50px" : "50px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Ships" {...a11yProps(0)} />
                                                                <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : '100px', maxWidth: sized ? "150px" : "155px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Inspection Tasks" {...a11yProps(1)} />
                                                            </Tabs></> : localStorage.getItem("UserRoles") == "External Client"
                                                            ? <>
                                                                <Tabs value={value} onChange={handleChange} className={classes.Hoverclr} aria-label="simple tabs example">
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "80px" : "80px", maxWidth: sized ? "50px" : "50px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Overview" {...a11yProps(0)} />
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : "100px", maxWidth: sized ? "100px" : "100px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Documents" {...a11yProps(2)} />
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : "100px", maxWidth: sized ? "100px" : "135px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Photographs" {...a11yProps(3)} />
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "50px" : '50px', maxWidth: sized ? "80px" : "80px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Reports" {...a11yProps(4)} />
                                                                </Tabs></>
                                                            : localStorage.getItem("UserRoles") == "Client" ?
                                                                <><Tabs value={value} onChange={handleChange} className={classes.Hoverclr} aria-label="simple tabs example">
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "80px" : "80px", maxWidth: sized ? "50px" : "50px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Overview" {...a11yProps(0)} />
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : "100px", maxWidth: sized ? "100px" : "100px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Documents" {...a11yProps(3)} />
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : "100px", maxWidth: sized ? "120px" : "120px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Photographs" {...a11yProps(6)} />
                                                                    <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "50px" : '50px', maxWidth: sized ? "80px" : "80px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Reports" {...a11yProps(4)} />
                                                                </Tabs> </> : <>
                                                                    <Tabs value={value} onChange={handleChange} className={classes.Hoverclr} aria-label="simple tabs example">
                                                                        <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "80px" : "80px", maxWidth: sized ? "50px" : "50px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Ships" {...a11yProps(0)} />
                                                                        <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : "100px", maxWidth: sized ? "100px" : "100px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Documents" {...a11yProps(3)} />
                                                                        <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : "100px", maxWidth: sized ? "100px" : "135px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Photographs" {...a11yProps(5)} />
                                                                        <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "100px" : '100px', maxWidth: sized ? "150px" : "150px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Inspection Tasks" {...a11yProps(2)} />
                                                                        <Tab className={sized ? "f-size-10 fw-bold" : "f-size-18 fw-bold"} style={{ minWidth: sized ? "50px" : '50px', maxWidth: sized ? "80px" : "80px", textTransform: "none", fontFamily: "Open Sans, sans-serif" }} label="Reports" {...a11yProps(4)} />
                                                                    </Tabs>
                                                                </>
                                            }
                                            </>}</>}
                                </div>
                                <div className={topBar ? "col-md-1 col-lg-1 col-xl-1 pl-0 pr-0 p-0 d-flex justify-content-end" : reSize ? "col-md-2 col-lg-2 pl-0 p-0 pr-0 col-xl-2 d-flex justify-content-end" : "col-md-2 col-lg-2 pl-0 p-0 pr-0 col-xl-2 d-flex justify-content-end"}>
                                    <div className={reSize ? "row w-100 mr-0 pr-0 d-flex justify-content-end" : "row w-100 mr-0 pl-0"}>
                                        <div className="col-md-12 col-lg-12 col-xl-12 mr-0 pr-0 d-flex align-items-center justify-content-end text-right">
                                            {reSize ? <></> : <>
                                                {topBar ? <></> : <>
                                                    <div className={reSize ? "rounded-circle" : "rounded-circle"} style={{ minWidth: "36px", minHeight: "36px", maxWidth: "36px", maxHeight: "36px", border: "1px solid #000000" }}>
                                                        <label className="pt-1 mt-1 f-size-15 fw-600 d-flex justify-content-center">{currentUser ? (currentUser?.name.charAt(0)).toUpperCase() : ""}</label>
                                                    </div></>}
                                                <label className="pt-2 pr-0 pl-2 word-break f-size-12 fw-600" style={{ paddingLeft: "8px" }}>{currentUser.name.split("@")[0]}</label></>}
                                            {currentUser ? (
                                                // <div className="ng-star-inserted h-menu col-sm-3 text-right">
                                                <div className="ng-star-inserted h-menu text-right">
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle nav caret className="select-dropdown">
                                                            <IconButton
                                                                className="p-0"
                                                                aria-label="more"
                                                                aria-haspopup="true"
                                                                aria-controls="long-menu"
                                                            ><MoreVertIcon style={{ color: "#000000" }} />
                                                            </IconButton>
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <h5 className="dropdown-item-text mb-0 f-size-15">
                                                                {currentUser.name.split("@")[0]}
                                                            </h5>
                                                            <p className="dropdown-item-text text-muted mb-0 f-size-13 fontSize-dropdown">
                                                                {currentUser.email}
                                                            </p>
                                                            <DropdownItem divider />
                                                            <DropdownItem className='fontSize-dropdown f-size-13' onClick={() => ChangePwd("/changepassword")}>
                                                                Change Password
                                                            </DropdownItem>
                                                            <DropdownItem divider />

                                                            <DropdownItem className='fontSize-dropdown f-size-13' onClick={() => LogOutView("handleLogout")}>
                                                                Sign Out
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </div>

                                            ) : null}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <main className={classes.content}>
                        <div className={classes.toolbar} />
                        <TabPanel value={value} index={0}>

                        </TabPanel>
                        <TabPanel value={value} index={1}>

                        </TabPanel>
                        <TabPanel value={value} index={2}>

                        </TabPanel>
                        <TabPanel value={value} index={3}>

                        </TabPanel>
                        <TabPanel value={value} index={4}>

                        </TabPanel>
                        <TabPanel value={value} index={5}>

                        </TabPanel>
                        <TabPanel value={value} index={6}>

                        </TabPanel>
                        <TabPanel value={value} index={7}>

                        </TabPanel>
                    </main>
                </div>
            }
            {
                !isMobile ?
                    <Drawer
                        variant="permanent"
                        className={clsx(classes.drawer, {
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                            [classes.paperHeight]: window.location.pathname === '/shiplist' || window.location.pathname === '/newenquiry' || window.location.pathname === '/ship/overview' || window.location.pathname === '/finalreport' || window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' || window.location.pathname === '/changepassword' || window.location.pathname === '/sampleships' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit',
                        })}
                        classes={{
                            paper: clsx({
                                [classes.drawerOpen]: open,
                                [classes.drawerClose]: !open,
                            }),
                        }}
                    >
                        <div style={{ position: 'relative', height: '84px' }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '18px', // gap from top
                                    bottom: '18px', // gap from bottom
                                    right: 0,
                                    width: '1px',
                                    backgroundColor: '#499AC8',
                                }}
                            />
                            {(window.location.pathname === '/shiplist' || window.location.pathname === '/newenquiry' || window.location.pathname === '/ship/overview' || window.location.pathname === '/finalreport' || window.location.pathname === '/dashboard' || window.location.pathname === "/changepassword" ||
                                window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
                                window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspector/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
                                window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
                                window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit' ||
                                window.location.pathname === '/lookupdata/opa' || window.location.pathname === '/lookupdata/opa/add' || window.location.pathname === '/lookupdata/opa/edit' ||
                                window.location.pathname === '/projectmaster/shipdocument' || window.location.pathname === '/projectmaster/yarddocument' || window.location.pathname === '/projectmaster/prebeachingdocument' ||
                                window.location.pathname === '/projectmaster/trainingdocument' || window.location.pathname === '/projectmaster/statementdocument' || window.location.pathname === '/sampleships' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit'
                            ) ? <>

                                <div className={`justify-content-center  align-items-center ${window.location.pathname == "/ship/overview" ? classes.topMenu1 : localStorage.getItem("UserRoles").toLowerCase() === "client" ? classes.topMenu1 : classes.topMenu}`} style={{ display: window.location.pathname === '/ship/overview' || (window.location.pathname === '/shiplist' && (localStorage.getItem("UserRoles").toLowerCase() == "client")) ? 'flex' : 'none' }}>
                                    <div className="m-auto p-0 row ml-0 d-flex align-items-center" style={{ height: "84px" }}>
                                        <div className='col-8 col-lg-8 col-md-8 col-xl-8 pl-3 ml-0 py-0 d-flex align-items-center' >
                                            <img src={aheadlogo} height={'74px'} />
                                        </div>
                                        {/* <div className='col-3 col-lg-3 col-md-3 col-xl-3 mt-2 pt-1 ml-0' style={{ paddingLeft: '25px' }}>
                                            <img src={ShipLogo} style={{ width: '160%', marginTop: '8px', marginLeft: '-3px' }} />
                                        </div>
                                        <div className='col-4 col-lg-4 col-md-4 col-xl-4 m-auto  pt-2 ' >
                                            <h5 className='fw-600 pl-0' style={{ fontWeight: "bolder", fontSize: '14px', marginTop: '8px', marginLeft: '-10px' }}>Marine<br></br>Mechanics</h5>
                                        </div> */}
                                    </div>

                                </div>
                                <div className={` justify-content-center  align-items-center ${window.location.pathname == "/ship/overview" ? classes.topMenu1 : localStorage.getItem("UserRoles").toLowerCase() === "client" ? classes.topMenu1 : classes.topMenu}`} style={{ display: window.location.pathname !== '/ship/overview' && (window.location.pathname !== '/shiplist' || localStorage.getItem("UserRoles").toLowerCase() !== "client") ? 'flex' : 'none' }}>
                                    {localStorage.getItem("UserRoles").toLowerCase() !== "client" ?
                                        <div className="m-auto row ml-0 d-flex align-items-center" style={{ height: "84px" }}>
                                            <div className='col-8 col-lg-8 col-md-8 col-xl-8 d-flex align-items-center  pt-0 py-0 pl-3 ml-0'>
                                                <img src={aheadlogo} height={'74px'} />
                                            </div>
                                            {/* <div className='col-8 col-lg-8 col-md-8 col-xl-8 m-auto pt-2 pl-2'>
                                                <h5 className='f-size-13 fw-600 pl-0' style={{ fontWeight: "bolder" }}>Marine<br></br>Mechanics</h5>
                                            </div> */}
                                        </div>
                                        :
                                        <div className="m-auto p-0 row ml-0 d-flex align-items-center" style={{ height: "84px" }}>
                                            <div className='col-8 col-lg-8 col-md-8 col-xl-8 pl-3 py-0 ml-0 d-flex align-items-center' >
                                                <img src={aheadlogo} height={'74px'} />
                                            </div>
                                            {/* <div className='col-3 col-lg-3 col-md-3 col-xl-3 mt-2 pt-1 ml-0' style={{ paddingLeft: '25px' }}>
                                                <img src={ShipLogo} style={{ width: '160%', marginTop: '8px', marginLeft: '-3px' }} />
                                            </div>
                                            <div className='col-4 col-lg-4 col-md-4 col-xl-4 m-auto  pt-2 ' >
                                                <h5 className='fw-600 pl-0' style={{ fontWeight: "bolder", fontSize: '14px', marginTop: '8px', marginLeft: '-10px' }}>Marine<br></br>Mechanics</h5>
                                            </div> */}
                                        </div>
                                    }
                                </div>
                            </> : <>
                                <div className={classes.toolbar + " pl-0 " + `${window.location.pathname == "/ship/overview" ? classes.topMenu1 : localStorage.getItem("UserRoles").toLowerCase() === "client" ? classes.topMenu1 : classes.topMenu}`} >
                                    {localStorage.getItem("UserRoles").toLowerCase() == "client" ?
                                        <div className="m-auto d-flex align-items-center p-0 row ml-0" style={{ height: "84px" }}>
                                            <div className='col-8 d-flex align-items-center col-lg-8 col-md-8 col-xl-8 pl-3 py-0 ml-0' >
                                                <img src={aheadlogo} height={'74px'} />
                                            </div>
                                            {/* <div className='col-3 col-lg-3 col-md-3 col-xl-3 mt-2 pt-1 ml-0' style={{ paddingLeft: '25px' }}>
                                                <img src={ShipLogo} style={{ width: '169%', marginTop: '8px', marginLeft: '0px' }} />
                                            </div>
                                            <div className='col-4 col-lg-4 col-md-4 col-xl-4 m-auto  pt-2 ' >
                                                <h5 className='fw-600 pl-0' style={{ fontWeight: "bolder", fontSize: '14px', marginTop: '8px', marginLeft: '-5px' }}>Marine<br></br>Mechanics</h5>
                                            </div> */}
                                        </div>
                                        :
                                        <div className='m-auto row ml-0 d-flex align-items-center'>
                                            <div className='col-8 col-lg-8 col-md-8 col-xl-8 mt-0 pt-0 py-0 pl-3 ml-0 d-flex align-items-center'>
                                                <img src={aheadlogo} />
                                            </div>
                                            {/* <div className='col-8 col-lg-8 col-md-8 col-xl-8 m-auto pt-2 pl-4'>
                                                <h5 className='f-size-13 fw-600 pl-1' style={{ fontWeight: "bolder", paddingLeft: "20px" }}>Marine Mechanics</h5>
                                            </div> */}
                                        </div>

                                    }
                                    {localStorage.getItem("UserRoles").toLowerCase() !== "client" &&
                                        <IconButton onClick={handleDrawerClose}>
                                            {<MenuIcon />
                                            }
                                        </IconButton>
                                    }
                                </div></>}
                        </div>
                        {menuToggle ?
                            (window.location.pathname === '/shipparticulars/add' || window.location.pathname === '/incharge/add' || window.location.pathname === '/settings/add') && (
                                <List className="ml-auto text-center scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: "240px", height: "calc(100vh - 84px)", bottom: 0, marginLeft: "auto" }}>
                                    {['Basic Information', 'In Charge', 'Settings'].map((text, index) => (
                                        <ListItem className="" button key={text} onClick={() => { CancelPopup(index + 1, text.replaceAll(" ", ""), "ProjectNavigation") }}>
                                            <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                            <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                        </ListItem>
                                    ))}
                                </List>) :
                            (window.location.pathname === '/shipparticulars/add' || window.location.pathname === '/incharge/add' || window.location.pathname === '/settings/add') && (
                                <List className="ml-auto text-center scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: "64px", height: "calc(100vh - 84px)", bottom: 0, marginLeft: "auto" }}>
                                    <Tooltip title="In Charge" placement="right" arrow>
                                        <ListItem id="ICL" className="" button onClick={() => editnavigate('/incharge/add', "edit")}>
                                            <ListItemText id="IC" className="textNaviIcon text-center" primary="IC" />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Basic Information " placement="right" arrow>
                                        <ListItem id="SPL" className="" button onClick={() => editnavigate('/shipparticulars/add', "edit")}>
                                            <ListItemText id="SP" className="textNaviIcon text-center" primary="SP" />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Settings" placement="right" arrow>
                                        <ListItem id="SL" className="" button onClick={() => editnavigate('/settings/add', "edit")}>
                                            <ListItemText id="S" className="textNaviIcon text-center" primary="S" />
                                        </ListItem>
                                    </Tooltip>
                                </List>)}
                        {menuToggle ?
                            (window.location.pathname === '/incharge/edit' || window.location.pathname === '/shipparticulars/edit' || window.location.pathname === '/historylog' || window.location.pathname === '/ship/finalsubmit' || window.location.pathname === '/settings/edit' || window.location.pathname === '/deleteship/deleteship') && (
                                <List className="text-center pt-4 scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: 240, height: "calc(100vh - 84px)", bottom: 0 }}>
                                    {localStorage.getItem("UserRoles").toLowerCase() == "admin" ? ['Basic Information', 'In Charge', 'Settings', 'History Log', 'Final Submit', 'Delete Ship'].map((text, index) => (
                                        <ListItem className="" button key={text} onClick={() => { CancelPopup(index + 1, text.replaceAll(" ", ""), "EditNavigation") }}>
                                            {index === 5 ?
                                                <>
                                                    <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} style={{ color: 'red' }} />
                                                    <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23, color: 'red' }} />
                                                </>
                                                :
                                                <>
                                                    <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                                    <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                                </>
                                            }
                                        </ListItem>
                                    )) : ['Basic Information', 'In Charge', 'Settings', 'History Log'].map((text, index) => (
                                        <ListItem className="" button key={text} onClick={() => { CancelPopup(index + 1, text.replaceAll(" ", ""), "EditNavigation") }}>
                                            <ListItemText className="px-3 ml-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                            <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                                        </ListItem>
                                    ))}
                                </List>) : (window.location.pathname === '/incharge/edit' || window.location.pathname === '/shipparticulars/edit' || window.location.pathname === '/ship/finalsubmit' /* || window.location.pathname === '/process/edit' */ || window.location.pathname === '/historylog' /* || window.location.pathname === '/basicinformation/edit */ || window.location.pathname === '/settings/edit' || window.location.pathname === '/deleteship/deleteship') && (
                                    <List className="ml-auto text-center pt-4 scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: "64px", height: "calc(100vh - 84px)", bottom: 0, marginLeft: "auto" }}>
                                        <Tooltip title="Basic Information" placement="right" arrow>
                                            <ListItem id="SPL" className="" button onClick={() => editnavigate('/shipparticulars/edit', "edit")}>
                                                <ListItemText id="SP" className="textNaviIcon text-center" primary="SP" />
                                            </ListItem>
                                        </Tooltip>

                                        <Tooltip title="In Charge" placement="right" arrow>
                                            <ListItem id="ICL" className="" button onClick={() => editnavigate('/incharge/edit', "edit")}>
                                                <ListItemText id="IC" className="textNaviIcon text-center" primary="IC" />
                                            </ListItem>
                                        </Tooltip>

                                        <Tooltip title="Settings" placement="right" arrow>
                                            <ListItem id="SL" className="" button onClick={() => editnavigate('/settings/edit', "edit")}>
                                                <ListItemText id="S" className="textNaviIcon text-center" primary="S" />
                                            </ListItem>
                                        </Tooltip>
                                        <Tooltip title="History Log" placement="right" arrow>
                                            <ListItem id="HLL" className="" button onClick={() => editnavigate('/historylog', "edit")}>
                                                <ListItemText id="HL" className="textNaviIcon text-center" primary="HL" />
                                            </ListItem>
                                        </Tooltip>
                                        <Tooltip title="Delete Ship" placement="right" arrow>
                                            <ListItem id="DPL" className="" button onClick={() => editnavigate('/deleteship/deleteship', "edit")}>
                                                <ListItemText id="DP" className="textNaviIcon text-center" primary="DP" style={{ color: 'red' }} />
                                            </ListItem>
                                        </Tooltip>
                                    </List>)}
                        {menuToggle ?
                            (window.location.pathname === '/inspection/vesselparticular' || window.location.pathname === '/inspection/summary' || window.location.pathname === '/inspection/comparegrade' || window.location.pathname === '/inspection/operationaldata' || window.location.pathname === '/inspection/gradingdata'
                                || window.location.pathname === '/inspection/keynotableitems' || window.location.pathname === '/inspection/designconstruction' || window.location.pathname === '/inspection/hull' || window.location.pathname === '/inspection/poopdeck' || window.location.pathname === '/inspection/maindeck' || window.location.pathname === '/inspection/ballasttanks'
                                || window.location.pathname === '/inspection/galleyaccomodation' || window.location.pathname === '/inspection/navigationbridge' || window.location.pathname === '/inspection/engineroom' || window.location.pathname === '/inspection/safetyappliances' || window.location.pathname === '/inspection/lifesavingequipment'
                                || window.location.pathname === '/inspection/safeworking' || window.location.pathname === '/inspection/decarbanizationsummary' || window.location.pathname === '/inspection/pollutioncontrol' || window.location.pathname === '/inspection/onboardmanagment' || window.location.pathname === '/inspection/cargosystem' || window.location.pathname === '/inspection/concludingstatement' || window.location.pathname === '/inspection/container/cargocondition'
                                || window.location.pathname === '/inspection/container/cargosystems' || window.location.pathname === '/inspection/container/lifting' || window.location.pathname === '/inspection/container/closing' || window.location.pathname === '/inspection/container/securing' || window.location.pathname === '/inspection/bulker/cargocondition' || window.location.pathname === '/inspection/bulker/cargosystems'
                                || window.location.pathname === '/inspection/bulker/lifting' || window.location.pathname === '/inspection/bulker/closing' || window.location.pathname === '/inspection/bulker/securing' || window.location.pathname === '/inspection/tanker/cargotanks' || window.location.pathname === '/inspection/tanker/pipingsystem' || window.location.pathname === '/inspection/tanker/monitoring'
                                || window.location.pathname === '/inspection/gascarrier/lng/cargotanks' || window.location.pathname === '/inspection/gascarrier/lng/pipingsystem' || window.location.pathname === '/inspection/gascarrier/lng/monitoring' || window.location.pathname === '/inspection/gascarrier/lng/equipment'
                                || window.location.pathname === '/inspection/gascarrier/lpg/cargotanks' || window.location.pathname === '/inspection/gascarrier/lpg/pipingsystem' || window.location.pathname === '/inspection/gascarrier/lpg/monitoring' || window.location.pathname === '/inspection/gascarrier/lpg/equipment' || window.location.pathname === '/inspection/finalsubmit')
                            && (
                                <List className='scroll-hidden' style={{ overflowY: 'auto', width: 240, height: "calc(100vh - 84px)", backgroundColor: "#F6F6F6" }}>
                                    {(() => {
                                        const items = [
                                            { id: "VesselParticular", path: "inspection/vesselparticular", name: "Vessel Particulars" },
                                            { id: "InspectionSummary", path: "inspection/summary", name: "Inspection Summary" },
                                            isGradeApplicable && { id: "CompareAheadGrade", path: "inspection/comparegrade", name: "Ahead Grade" },
                                            { id: "Operation", path: "inspection/operationaldata", name: "Operational Data" },
                                            { id: "GradingData", path: "inspection/gradingdata", name: "Grading Data" },
                                            { id: "Design", path: "inspection/designconstruction", name: "Design & Construction" },
                                            { id: "Hull", path: "inspection/hull", name: "Hull" },
                                            { id: "PoopDeck", path: "inspection/poopdeck", name: "Foc’scle & Poop Deck" },
                                            { id: "MainDeck", path: "inspection/maindeck", name: "Main Deck & Fittings" },
                                            { id: "Ballast", path: "inspection/ballasttanks", name: "Ballast Tanks & Void Spaces" },
                                            { id: "Galley", path: "inspection/galleyaccomodation", name: "Galley & Accomodation" },
                                            { id: "NavigationBridge", path: "inspection/navigationbridge", name: "Navigation Bridge and Communication" },
                                            { id: "EngineRoom", path: "inspection/engineroom", name: "Engine Room, Machinery & Machinery Spaces" },
                                            { id: "FireSafety", path: "inspection/safetyappliances", name: "Fire Fighting Appliances" },
                                            { id: "LifeSaving", path: "inspection/lifesavingequipment", name: "Life Saving Equipment" },
                                            { id: "SafeWorking", path: "inspection/safeworking", name: "Safe Working" },
                                            { id: "Pollution", path: "inspection/pollutioncontrol", name: "Pollution Control" },
                                            { id: "OnboardManagement", path: "inspection/onboardmanagment", name: "Onboard Management and Crew Welfare" },
                                        ].filter(Boolean);

                                        const cargoIndex = items.length + 1;
                                        const cargoNum = cargoIndex < 10 ? `0${cargoIndex}` : `${cargoIndex}`;

                                        return (
                                            <>
                                                {items.map((item, idx) => {
                                                    const num = (idx + 1) < 10 ? `0${idx + 1}` : `${idx + 1}`;
                                                    return (
                                                        <ListItem key={item.id} button onClick={() => CopyDaily(item.id, item.path, "DailyNavigation")}>
                                                            <Typography className={classes.leftCount}>{num}  &nbsp;</Typography>
                                                            <ListItemText id={item.id + "1"} className='pl-3 textNaviIcon' primary={item.name} />
                                                            <NavigateNextIcon id={item.id} className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                    );
                                                })}
                                                <ListItem button onClick={() => { setLess(!less) }} >
                                                    <Typography className={classes.leftCount}>{cargoNum}  &nbsp;</Typography>
                                                    <ListItemText className='pl-3' primary="Cargo Systems" />
                                                    <NavigateNextIcon className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                    {less ? <ExpandMore /> : <ExpandLess />}
                                                    <Divider />
                                                </ListItem>
                                            </>
                                        );
                                    })()}
                                    {less ? "" : <>
                                        <ListItem onClick={() => CopyDaily("CargoSystem", "inspection/cargosystem", "DailyNavigation")} button>
                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >&nbsp;I&nbsp;</Typography>
                                            <ListItemText id={"CargoSystems" + "1"} className='pl-3 textNaviIcon' primary="Cargo Systems Summary" />
                                            <NavigateNextIcon id="CargoSystems" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        {shiptype === 9 ?
                                            <>
                                                <ListItem button onClick={() => CopyDaily("Cargocon", "inspection/container/cargocondition", "DailyNavigation")} >
                                                    <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                    <ListItemText id={"Cargocon" + "1"} className='pl-3 textNaviIcon' primary="Cargo Condition" />
                                                    <NavigateNextIcon id="Cargocon" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                    <Divider />
                                                </ListItem>
                                                <ListItem button onClick={() => CopyDaily("Cargosys", "inspection/container/cargosystems", "DailyNavigation")} >
                                                    <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                    <ListItemText id={"Cargosys" + "1"} className='pl-3 textNaviIcon' primary="Cargo Systems" />
                                                    <NavigateNextIcon id="Cargosys" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                    <Divider />
                                                </ListItem>
                                                <ListItem button onClick={() => CopyDaily("Lifting", "inspection/container/lifting", "DailyNavigation")} >
                                                    <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                    <ListItemText id={"Lifting" + "1"} className='pl-3 textNaviIcon' primary="Lifting Appliances" />
                                                    <NavigateNextIcon id="Lifting" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                    <Divider />
                                                </ListItem>
                                                <ListItem button onClick={() => CopyDaily("Closing", "inspection/container/closing", "DailyNavigation")} >
                                                    <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                    <ListItemText id={"Closing" + "1"} className='pl-3 textNaviIcon' primary="Closing Appliances" />
                                                    <NavigateNextIcon id="Closing" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                    <Divider />
                                                </ListItem>
                                                <ListItem button onClick={() => CopyDaily("Securing", "inspection/container/securing", "DailyNavigation")} >
                                                    <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  VI&nbsp;</Typography>
                                                    <ListItemText id={"Securing" + "1"} className='pl-3 textNaviIcon' primary="Cargo Securing" />
                                                    <NavigateNextIcon id="Securing" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                    <Divider />
                                                </ListItem>
                                            </> : shiptype === 10 ?
                                                <>
                                                    <ListItem button onClick={() => CopyDaily("bulkerCargocon", "inspection/bulker/cargocondition", "DailyNavigation")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                        <ListItemText id={"bulkerCargocon" + "1"} className='pl-3 textNaviIcon' primary="Cargo System Bulker" />
                                                        <NavigateNextIcon id="bulkerCargocon" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => CopyDaily("bulkerCargosys", "inspection/bulker/cargosystems", "DailyNavigation")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                        <ListItemText id={"bulkerCargosys" + "1"} className='pl-3 textNaviIcon' primary="Hatch Covers Condition" />
                                                        <NavigateNextIcon id="bulkerCargosys" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => CopyDaily("bulkerLifting", "inspection/bulker/lifting", "DailyNavigation")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                        <ListItemText id={"bulkerLifting" + "1"} className='pl-3 textNaviIcon' primary="Hatch Coamings Condition" />
                                                        <NavigateNextIcon id="bulkerLifting" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => CopyDaily("bulkerClosing", "inspection/bulker/closing", "DailyNavigation")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                        <ListItemText id={"bulkerClosing" + "1"} className='pl-3 textNaviIcon' primary="Documentation and Additional Features" />
                                                        <NavigateNextIcon id="bulkerClosing" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => CopyDaily("bulkerSecuring", "inspection/bulker/securing", "DailyNavigation")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  VI&nbsp;</Typography>
                                                        <ListItemText id={"bulkerSecuring" + "1"} className='pl-3 textNaviIcon' primary="Cargo Lifting Appliances" />
                                                        <NavigateNextIcon id="bulkerSecuring" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                </> : shiptype === 70 ?
                                                    <>
                                                        <ListItem button onClick={() => CopyDaily("CargotankLNG", "inspection/gascarrier/lng/cargotanks", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                            <ListItemText id={"CargotankLNG" + "1"} className='pl-3 textNaviIcon' primary="Cargo Tanks" />
                                                            <NavigateNextIcon id="CargtankLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("PipingsysLNG", "inspection/gascarrier/lng/pipingsystem", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                            <ListItemText id={"PipingsysLNG" + "1"} className='pl-3 textNaviIcon' primary="Pumping/Piping Systems" />
                                                            <NavigateNextIcon id="PipingsysLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("MonitoringLNG", "inspection/gascarrier/lng/monitoring", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                            <ListItemText id={"MonitoringLNG" + "1"} className='pl-3 textNaviIcon' primary="Monitoring/Safety Arrangements" />
                                                            <NavigateNextIcon id="MonitoringLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("EquipmentLNG", "inspection/gascarrier/lng/equipment", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                            <ListItemText id={"EquipmentLNG" + "1"} className='pl-3 textNaviIcon' primary="Equipment" />
                                                            <NavigateNextIcon id="EquipmentLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                    </> : shiptype === 71 ? <>
                                                        <ListItem button onClick={() => CopyDaily("CargotankLPG", "inspection/gascarrier/lpg/cargotanks", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                            <ListItemText id={"CargotankLPG" + "1"} className='pl-3 textNaviIcon' primary="Cargo Tanks" />
                                                            <NavigateNextIcon id="CargtankLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("PipingsysLPG", "inspection/gascarrier/lpg/pipingsystem", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                            <ListItemText id={"PipingsysLPG" + "1"} className='pl-3 textNaviIcon' primary="Pumping/Piping Systems" />
                                                            <NavigateNextIcon id="PipingsysLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("MonitoringLPG", "inspection/gascarrier/lpg/monitoring", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                            <ListItemText id={"MonitoringLPG" + "1"} className='pl-3 textNaviIcon' primary="Monitoring/Safety Arrangements" />
                                                            <NavigateNextIcon id="MonitoringLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("EquipmentLPG", "inspection/gascarrier/lpg/equipment", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                            <ListItemText id={"EquipmentLPG" + "1"} className='pl-3 textNaviIcon' primary="Equipment" />
                                                            <NavigateNextIcon id="EquipmentLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                    </> : <>
                                                        <ListItem button onClick={() => CopyDaily("Cargotank", "inspection/tanker/cargotanks", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                            <ListItemText id={"Cargotank" + "1"} className='pl-3 textNaviIcon' primary="Cargo Tanks" />
                                                            <NavigateNextIcon id="Cargtank" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("Pipingsys", "inspection/tanker/pipingsystem", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                            <ListItemText id={"Pipingsys" + "1"} className='pl-3 textNaviIcon' primary="Pumping/Piping Systems" />
                                                            <NavigateNextIcon id="Pipingsys" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => CopyDaily("Monitoring", "inspection/tanker/monitoring", "DailyNavigation")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                            <ListItemText id={"Monitoring" + "1"} className='pl-3 textNaviIcon' primary="Monitoring/Safety Arrangements" />
                                                            <NavigateNextIcon id="Monitoring" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                    </>}
                                    </>}

                                    {/*   <ListItem button onClick={() => {setMore(!more)}}>
                                            <Typography className={classes.leftCount} style={{ marginLeft: "15px" }} >B  &nbsp;</Typography>
                                            <ListItemText className='pl-3' primary="Bulker" />
                                            <NavigateNextIcon className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            {more ? <ExpandMore /> : <ExpandLess />}
                                            <Divider />
                                        </ListItem>
                                        {more ? "" : <> 
                                       
                                        </>}*/}
                                    {/*   <ListItem button onClick={() => {setTopMore(!topmore)}}>
                                            <Typography className={classes.leftCount} style={{ marginLeft: "15px" }} >C  &nbsp;</Typography>
                                            <ListItemText className='pl-3' primary="Tanker" />
                                            <NavigateNextIcon className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            {topmore ? <ExpandMore /> : <ExpandLess />}
                                            <Divider />
                                        </ListItem>
                                        {topmore ? "" : <>
                                      
                                            
                                        </>}
                                        
                                        </>} */}
                                    <ListItem button onClick={() => CopyDaily("DecarbanizationSummary", "inspection/decarbanizationsummary", "DailyNavigation")} >
                                        <Typography className={classes.leftCount}>20  &nbsp;</Typography>
                                        <ListItemText id={"DecarbanizationSummary" + "1"} className='pl-3 textNaviIcon' primary="Decarbanization Summary" />
                                        <NavigateNextIcon id="DecarbanizationSummary" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                        <Divider />
                                    </ListItem>
                                    <ListItem button onClick={() => CopyDaily("Concluding", "inspection/concludingstatement", "DailyNavigation")} >
                                        <Typography className={classes.leftCount}>21  &nbsp;</Typography>
                                        <ListItemText id={"Concluding" + "1"} className='pl-3 textNaviIcon' primary="Concluding Statement" />
                                        <NavigateNextIcon id="Concluding" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                        <Divider />
                                    </ListItem>
                                    <ListItem button onClick={() => CopyDaily("FinalSubmit", "inspection/finalsubmit", "DailyNavigation")} >
                                        <Typography className={classes.leftCount}>22 &nbsp;</Typography>
                                        <ListItemText id={"FinalSubmit" + "1"} className='pl-3 textNaviIcon' primary="Submit" />
                                        <NavigateNextIcon id="FinalSubmit" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                        <Divider />
                                    </ListItem>

                                </List>)
                            :
                            (window.location.pathname === '/inspection/vesselparticular' || window.location.pathname === '/inspection/summary' || window.location.pathname === '/inspection/comparegrade' || window.location.pathname === '/inspection/operationaldata' || window.location.pathname === '/inspection/gradingdata'
                                || window.location.pathname === '/inspection/keynotableitems' || window.location.pathname === '/inspection/designconstruction' || window.location.pathname === '/inspection/hull' || window.location.pathname === '/inspection/poopdeck' || window.location.pathname === '/inspection/maindeck' || window.location.pathname === '/inspection/ballasttanks'
                                || window.location.pathname === '/inspection/galleyaccomodation' || window.location.pathname === '/inspection/navigationbridge' || window.location.pathname === '/inspection/engineroom' || window.location.pathname === '/inspection/safetyappliances' || window.location.pathname === '/inspection/lifesavingequipment'
                                || window.location.pathname === '/inspection/safeworking' || window.location.pathname === 'inspection/decarbanizationsummary' || window.location.pathname === '/inspection/pollutioncontrol' || window.location.pathname === '/inspection/onboardmanagment' || window.location.pathname === '/inspection/cargosystem' || window.location.pathname === '/inspection/concludingstatement'
                                || window.location.pathname === '/inspection/container/cargocondition' || window.location.pathname === '/inspection/container/cargosystems' || window.location.pathname === '/inspection/container/lifting' || window.location.pathname === '/inspection/container/closing' || window.location.pathname === '/inspection/container/securing' || window.location.pathname === '/inspection/bulker/cargocondition' || window.location.pathname === '/inspection/bulker/cargosystems'
                                || window.location.pathname === '/inspection/bulker/lifting' || window.location.pathname === '/inspection/bulker/closing' || window.location.pathname === '/inspection/bulker/securing' || window.location.pathname === '/inspection/tanker/cargotanks' || window.location.pathname === '/inspection/tanker/pipingsystem' || window.location.pathname === '/inspection/tanker/monitoring' || window.location.pathname === '/inspection/gascarrier/lng/cargotanks' || window.location.pathname === '/inspection/gascarrier/lng/pipingsystem' || window.location.pathname === '/inspection/gascarrier/lng/monitoring' || window.location.pathname === '/inspection/gascarrier/lng/equipment'
                                || window.location.pathname === '/inspection/gascarrier/lpg/cargotanks' || window.location.pathname === '/inspection/gascarrier/lpg/pipingsystem' || window.location.pathname === '/inspection/gascarrier/lpg/monitoring' || window.location.pathname === '/inspection/gascarrier/lpg/equipment')
                            && (
                                <List className='scroll-hidden' style={{ overflowY: 'auto', width: 64, height: "calc(100vh - 84px)", backgroundColor: "#F6F6F6" }}>
                                    <Tooltip title="Vessel Particulars" placement="right" arrow>
                                        <ListItem button id="VPL" onClick={() => CancelPopupUser("/inspection/vesselparticular", "DailyTasknavigate")}>
                                            <Typography id="VPT" className={classes.leftCount}>01  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Inspection Summary" placement="right" arrow>
                                        <ListItem button id="INSL" onClick={() => CancelPopupUser("/inspection/summary", "DailyTasknavigate")}>
                                            <Typography id="INST" className={classes.leftCount}>02  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Compare your Ahead Grade" placement="right" arrow>
                                        <ListItem button id="CAGL" onClick={() => CancelPopupUser("/inspection/comparegrade", "DailyTasknavigate")}>
                                            <Typography id="CAGT" className={classes.leftCount}>03  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Operational Data" placement="right" arrow>
                                        <ListItem button id="OPAL" onClick={() => CancelPopupUser("/inspection/operationaldata", "DailyTasknavigate")}>
                                            <Typography id="OPAT" className={classes.leftCount}>04  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>                                       <Tooltip title="Key Notable Items" placement="right" arrow>
                                        <ListItem button id="KNIL" onClick={() => CancelPopupUser("/inspection/keynotableitems", "DailyTasknavigate")}>
                                            <Typography id="KNIT" className={classes.leftCount}>05  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Grading Data" placement="right" arrow>
                                        <ListItem button id="GDL" onClick={() => CancelPopupUser("/inspection/gradingdata", "DailyTasknavigate")}>
                                            <Typography id="GDT" className={classes.leftCount}>06  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Design & Construction" placement="right" arrow>
                                        <ListItem button id="DCL" onClick={() => CancelPopupUser("/inspection/designconstruction", "DailyTasknavigate")}>
                                            <Typography id="DCT" className={classes.leftCount}>07  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Hull" placement="right" arrow>
                                        <ListItem button id="HL" onClick={() => CancelPopupUser("/inspection/hull", "DailyTasknavigate")}>
                                            <Typography id="HT" className={classes.leftCount}>08  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Foc’scle & Poop Deck" placement="right" arrow>
                                        <ListItem button id="FPDL" onClick={() => CancelPopupUser("/inspection/poopdeck", "DailyTasknavigate")}>
                                            <Typography id="FPDT" className={classes.leftCount}>09  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Main Deck & Fittings" placement="right" arrow>
                                        <ListItem button id="MDFL" onClick={() => CancelPopupUser("/inspection/maindeck", "DailyTasknavigate")}>
                                            <Typography id="MDFT" className={classes.leftCount}>10  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Ballast Tanks & Void Spaces" placement="right" arrow>
                                        <ListItem button id="BTL" onClick={() => CancelPopupUser("/inspection/ballasttanks", "DailyTasknavigate")}>
                                            <Typography id="BTT" className={classes.leftCount}>11  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Galley & Accomodation" placement="right" arrow>
                                        <ListItem button id="GAL" onClick={() => CancelPopupUser("/inspection/galleyaccomodation", "DailyTasknavigate")}>
                                            <Typography id="GAT" className={classes.leftCount}>12  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Navigation Bridge and Communication" placement="right" arrow>
                                        <ListItem button id="NBCL" onClick={() => CancelPopupUser("/inspection/navigationbridge", "DailyTasknavigate")}>
                                            <Typography id="NBCT" className={classes.leftCount}>13  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Engine Room, Machinery & Machinery Spaces" placement="right" arrow>
                                        <ListItem button id="ERMSL" onClick={() => CancelPopupUser("/inspection/engineroom", "DailyTasknavigate")}>
                                            <Typography id="ERMST" className={classes.leftCount}>14  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Fire & Safety Appliances" placement="right" arrow>
                                        <ListItem button id="FSAL" onClick={() => CancelPopupUser("/inspection/safetyappliances", "DailyTasknavigate")}>
                                            <Typography id="FSAT" className={classes.leftCount}>15  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Life Saving Equipment" placement="right" arrow>
                                        <ListItem button id="LSEL" onClick={() => CancelPopupUser("/inspection/lifesavingequipment", "DailyTasknavigate")}>
                                            <Typography id="LSET" className={classes.leftCount}>16  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Safe Working" placement="right" arrow>
                                        <ListItem button id="SWL" onClick={() => CancelPopupUser("/inspection/safeworking", "DailyTasknavigate")}>
                                            <Typography id="SWT" className={classes.leftCount}>17  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Pollution Control" placement="right" arrow>
                                        <ListItem button id="PCPL" onClick={() => CancelPopupUser("/inspection/pollutioncontrol", "DailyTasknavigate")}>
                                            <Typography id="PCPT" className={classes.leftCount}>18  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Onboard Management and Crew Welfare" placement="right" arrow>
                                        <ListItem button id="OMCL" onClick={() => CancelPopupUser("/inspection/onboardmanagment", "DailyTasknavigate")}>
                                            <Typography id="OMCT" className={classes.leftCount}>19  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Decarbanization Summary" placement="right" arrow>
                                        <ListItem button id="DSL" onClick={() => CancelPopupUser("inspection/decarbanizationsummary", "DailyTasknavigate")}>
                                            <Typography id="DST" className={classes.leftCount}>20  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Cargo Systems" placement="right" arrow>
                                        <ListItem button id="CSL" onClick={() => CancelPopupUser("/inspection/cargosystem", "DailyTasknavigate")}>
                                            <Typography id="CST" className={classes.leftCount}>21  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                    <Tooltip title="Concluding Statement" placement="right" arrow>
                                        <ListItem button id="CSL" onClick={() => CancelPopupUser("/inspection/concludingstatement", "DailyTasknavigate")}>
                                            <Typography id="CST" className={classes.leftCount}>22  &nbsp;</Typography>
                                            <Divider />
                                        </ListItem>
                                    </Tooltip>
                                </List>)
                        }
                        {menuToggle ?
                            (window.location.pathname === '/ship/documents') &&
                            <List className="text-center position-fixed scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: localStorage.getItem("UserRoles").toLowerCase() == "client" ? 300 : 240, height: "calc(100vh - 84px)", bottom: 0 }} >
                                <ListItem className="" button key="Documents" onClick={() => SetActive("Documents")}>
                                    <ListItemText className="px-3 ml-3 textNaviIcon" id="ShipDocuments1" primary="Documents" />
                                    <NavigateNextIcon className="naviIcon d-none" id="ShipDocuments" style={{ width: 23, height: 23 }} />
                                </ListItem>
                            </List> : (window.location.pathname === '/ship/documents') &&
                            <List className="text-center position-fixed scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: 64, height: "calc(100vh - 84px)", bottom: 0 }} >
                                <Tooltip title="Documents" placement="right" arrow>
                                    <ListItem className="" id="SDL" button key="D" onClick={() => SetActive("D")}>
                                        <ListItemText className="textNaviIcon text-center" id="SD" primary="D" />
                                    </ListItem>
                                </Tooltip>
                            </List>}
                        {menuToggle ?
                            (window.location.pathname === '/ship/photographs') &&
                            <List className="text-center position-fixed scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: localStorage.getItem("UserRoles").toLowerCase() == "client" ? 300 : 240, height: "calc(100vh - 84px)", bottom: 0 }} >
                                <ListItem className="" button key="Ship Images" onClick={() => SetActive("ShipImages")}>
                                    <ListItemText className="px-3 ml-3 textNaviIcon" id="ShipImages1" primary="Photographs" />
                                    <NavigateNextIcon className="naviIcon d-none" id="ShipImages" style={{ width: 23, height: 23 }} />
                                </ListItem>
                            </List> : (window.location.pathname === '/ship/photographs') &&
                            <List className="text-center position-fixed scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: 64, height: "calc(100vh - 84px)", bottom: 0 }} >
                                <Tooltip title="Photographs" placement="right" arrow>
                                    <ListItem className="" id="SIL" button key="I" onClick={() => SetActive("I")}>
                                        <ListItemText className="textNaviIcon text-center" id="SI" primary="I" />
                                    </ListItem>
                                </Tooltip>
                            </List>}
                        {menuToggle ?
                            (window.location.pathname === '/usermanagement/admin' || window.location.pathname === '/usermanagement/admin/add' || window.location.pathname === '/usermanagement/admin/edit' ||
                                window.location.pathname === '/usermanagement/fieldinspector' || window.location.pathname === '/usermanagement/fieldinspector/add' || window.location.pathname === '/usermanagement/fieldinspector/edit' ||
                                window.location.pathname === '/usermanagement/client' || window.location.pathname === '/usermanagement/client/add' || window.location.pathname === '/usermanagement/client/edit' ||
                                window.location.pathname === '/usermanagement/externalclient' || window.location.pathname === '/usermanagement/externalclient/add' || window.location.pathname === '/usermanagement/externalclient/edit'
                            ) && (
                                <List className=' scroll-hidden' style={{ overflowY: 'auto', width: 240, height: "calc(100vh - 84px)", backgroundColor: "#F6F6F6" }}>
                                    {[{ 'id': 'UserMngt0', 'text': 'Admin' }, { 'id': 'UserMngt1', 'text': 'Field Inspector' }, { 'id': 'UserMngt2', 'text': 'Client' }, { 'id': 'UserMngt3', 'text': 'External Client' }].map((text, index) => (
                                        <ListItem className="" button key={text.text} onClick={() => { CancelPopupUser(index + 1, "UserMgntNavigation") }}>
                                            <ListItemText className="px-3 ml-3 textNaviIcon" id={text.id} primary={text.text} />
                                            <NavigateNextIcon className="naviIcon d-none" id={text.id + index} style={{ width: 23, height: 23 }} />
                                        </ListItem>
                                    ))}
                                </List>) : <></>}
                        {menuToggle ?
                            (window.location.pathname === '/sampleships' || window.location.pathname === '/activesampleships' || window.location.pathname === '/activesampleships/add' || window.location.pathname === '/activesampleships/edit') &&
                            (<List className=' scroll-hidden' style={{ overflowY: 'auto', width: 240, height: "calc(100vh - 84px)", backgroundColor: "#F6F6F6" }}>
                                {[{ 'id': 'ExterMngt0', 'text': 'Sample Ships' }, { 'id': 'ExterMngt1', 'text': 'Active Sample Ships' }].map((text, index) => (
                                    <ListItem className="" button key={text.text} onClick={() => { CancelPopupUser(index + 1, "ExternalMgntNavigation") }}>
                                        <ListItemText className="px-3 ml-3 textNaviIcon" id={text.id} primary={text.text} />
                                        <NavigateNextIcon className="naviIcon d-none" id={text.id + index} style={{ width: 23, height: 23 }} />
                                    </ListItem>
                                ))}
                            </List>) : <></>}
                        {menuToggle ?
                            (window.location.pathname === '/newenquiry') &&
                            <List className="text-center position-fixed scroll-hidden" style={{ overflowY: "auto", backgroundColor: "#F6F6F6", width: localStorage.getItem("UserRoles").toLowerCase() == "client" && window.location.pathname === '/newenquiry' ? 300 : 240, height: "calc(100vh - 84px)", bottom: 0 }} >
                                <ListItem className="" button key="NewEnquiry" onClick={() => SetActive("NewEnquiry")}>
                                    <ListItemText className="px-3 ml-3 textNaviIcon" id="NewEnquiry1" primary="New Enquiry" />
                                    <NavigateNextIcon className="naviIcon d-none" id="NewEnquiry" style={{ width: 23, height: 23 }} />
                                </ListItem>
                            </List> : <></>}
                    </Drawer>
                    : <></>
            }
            < Outlet />
            <div class="modal fade p-5 mt-5" id="cancelpopupPro" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                <div class="modal-dialog" role="document">
                    <div class={isMobile ? "modal-content" : "modal-content p-3"}>
                        <div class="modal-body pb-0">
                            <h1 className="text-center">
                                <img src={del}></img>
                            </h1>
                            <div className="text-center">
                                <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                        </div>
                        <div class="modal-footer border-top-0 m-auto">
                            <button type="button" class={isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={Cancel}><span className=""  >Yes</span></button>
                            <button type="button" id="closemodal1" class={isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopupPro").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade p-5 mt-5" id="cancelpopup2" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                <div class="modal-dialog" role="document">
                    <div class={isMobile ? "modal-content" : "modal-content p-3"}>
                        <div class="modal-body pb-0">
                            <h1 className="text-center">
                                <img src={del}></img>
                            </h1>
                            <div className="text-center">
                                <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                        </div>
                        <div class="modal-footer border-top-0 m-auto">
                            <button type="button" class={isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={SideBarCancel}><span className="" >Yes</span></button>
                            <button type="button" id="closemodal1" class={isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup2").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}
export default TopMenu;
